import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagingComponent } from './paging.component';
import { WucLinkModule } from '@inshared/website-ui-components';

@NgModule({
    declarations: [
        PagingComponent,
    ],
    imports: [
        WucLinkModule,
        CommonModule,
    ],
    exports: [
        PagingComponent,
    ]
})
export class PagingModule {
}
